<div class="course-creator">
  <div class="course-creator__left">
    <app-course-stepper
      [steps]="effectiveSteps()"
      [currentStep]="currentStep()"
      [completedSteps]="completedSteps()"
      [lockedSteps]="
        selectedCourse()?.status === 'PUBLISHED' || completedSteps().includes('publish')
          ? lockedStepsWhenPublished()
          : []
      "
      (stepClicked)="onStepClicked($event)"
    ></app-course-stepper>
  </div>
  <div class="course-creator__right">
    @switch (currentStep()) {
      @case ('settings') {
        <app-course-settings
          [layoutVariant]="layoutVariant()"
          (settingsDataChange)="onSettingsDataChange($event)"
          (stepCompleted)="onStepCompleted('settings')"
        ></app-course-settings>
      }
      @case ('generate') {
        <app-course-generate (stepCompleted)="onStepCompleted('generate')"></app-course-generate>
      }
      @case ('publish') {
        <app-course-publish
          [layoutVariant]="layoutVariant()"
          [selectedCourse]="selectedCourse()"
          (stepCompleted)="onStepCompleted('publish')"
        ></app-course-publish>
      }
      @case ('assign') {
        <app-course-assignments [courseId]="selectedCourse()?.id" (stepCompleted)="onStepCompleted('assign')"></app-course-assignments>
      }
    }
  </div>
</div>

